module.exports = __webpack_public_path__ + "static/media/WZ9.5a2960e6.jpg";